
import { useQuery } from '../../../lib/hooks/useQuery';
import { useMutation } from '../../../lib/hooks/useMutation';
import { customersApi } from '../../../lib/api/customers';
import { Customer, CustomerFilters } from '../../../lib/types';

export function useCustomers(filters?: CustomerFilters) {
  return useQuery(
    ['customers', JSON.stringify(filters)],
    () => customersApi.getCustomers(filters)
  );
}

export function useCustomer(id: string) {
  return useQuery(
    ['customers', id],
    () => customersApi.getById<Customer>(id),
    { enabled: !!id }
  );
}

export function useCustomerSearch() {
  return useMutation(
    (searchTerm: string) => customersApi.searchCustomers(searchTerm)
  );
}

export function useCustomerByPhone() {
  return useMutation(
    (phone: string) => customersApi.getCustomerByPhone(phone)
  );
}

export function useCustomerByEmail() {
  return useMutation(
    (email: string) => customersApi.getCustomerByEmail(email)
  );
}

export function useCreateCustomer() {
  return useMutation(
    (customerData: Partial<Customer>) => customersApi.create<Customer>(customerData),
    {
      onSuccess: () => {
        console.log('Customer created successfully');
      }
    }
  );
}

export function useUpdateCustomer() {
  return useMutation(
    ({ id, data }: { id: string; data: Partial<Customer> }) => 
      customersApi.update<Customer>(id, data),
    {
      onSuccess: () => {
        console.log('Customer updated successfully');
      }
    }
  );
}

export function useDeleteCustomer() {
  return useMutation(
    (id: string) => customersApi.delete(id),
    {
      onSuccess: () => {
        console.log('Customer deleted successfully');
      }
    }
  );
}
